// RESIZE DATA
function resizeData (resize_state) {
  return {
    type: 'RESIZE_STATE',
    resize_state
  };
}

const setResizeState = () => {
  return (dispatch) => {
    dispatch(resizeData({
      window_width: window.innerWidth,
      window_height: window.innerHeight
    }));
  };
};

// SCROLL DATA
function scrollData (scroll_state) {
  return {
    type: 'SCROLL_STATE',
    scroll_state
  };
}

function scrollDirection (direction) {
  return {
    type: 'SCROLL_DIRECTION',
    direction
  };
}

const setDirectionDown = () => {
  return (dispatch, getState) => {
    if (getState().scroll_direction == 'scrolling-up' || 'top') {
      setTimeout(() => {
        dispatch(scrollDirection('scrolling-down'));
      }, 50);
    }
  };
};

const setScrollDirection = (direction) => {
  return (dispatch) => {
    dispatch(scrollDirection(direction));
  };
};

const setScrollState = () => {
  return (dispatch, getState) => {
    const st = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    if (st < 100) {
      dispatch(scrollDirection('top'));
    }
    if (st > getState().window_dimensions.window_height) {
      dispatch(scrollData({
        cat_menu_wrapper: 'stick-it',
        portfolio_wrapper: 'add-margin'
      }));
    } else {
      dispatch(scrollData({
        cat_menu_wrapper: null,
        portfolio_wrapper: null
      }));
    }
  };
};

// EXPORTS
export {
  setScrollState,
  setResizeState,
  setDirectionDown,
  scrollDirection,
  scrollData,
  setScrollDirection
};



// WEBPACK FOOTER //
// ./src/redux/actions/a_window_data.js